import React, { useEffect, useState } from "react";
import AddToCartButton from "../AddToCartButton/AddToCartButton";
import "./ReserverLink.css";
import { useNavigate } from "react-router-dom";

export default function ReserveLink({
  courseId,
  levelId,
  amount,
  levelbadge,
  courseTitle,
  disabled,
  onClick,
}) {
     const navigate = useNavigate(); // if not already defined

  const [purchase, setPurchase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorCode, setErrorCode] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));


  const handleClick = (e) => {

  if (disabled) {
    e.preventDefault();
    e.stopPropagation();
    
    // Show alert, then redirect after user clicks OK
    alert("Please complete your profile first!");
    navigate("/registerprofile"); // redirect to profile page
    return;
  }

  // Call parent onClick if provided
  if (onClick) onClick(e);
};

  useEffect(() => {
    if (!user?.uid) {
      console.warn("No user found in localStorage");
      setLoading(false);
      return;
    }

    fetch(
      `https://agepcoatings.com/payments/check-purchase?uid=${user.uid}&levelId=${levelId}`
    )
      .then(async (res) => {
        if (res.status === 200) {
          const data = await res.json();
          console.log("Purchase data:", data);
          setPurchase(data.purchase);
        } else {
          setErrorCode(res.status);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, [user?.uid, levelId]);

  if (loading) return null;
  // 🚫 User not logged in → hide
  if (!user?.uid) {
    return null;
  }

  // ✅ Already purchased (full payment done)
  if (purchase?.paymentType === "full") {
    return <span>✅ Already Purchased</span>;
  }

  // ✅ Partial payment case
  if (purchase?.paymentType === "partial") {
    // 🟢 Condition: Remaining = 0 → show success
    if (purchase.remainAmount === 0) {
      return <span>✅ Already Purchased</span>;
    }

    return (
      <div>
        {/* <div style={{ marginBottom: "0.5rem", color: "#d9534f" }}>
          Please pay remaining {currency} {purchase.remainAmount}
        </div> */}
        <div
          className="reserve-container"
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          {/* <AddToCartButton
            courseId={courseId}
            levelId={levelId}
            courseTitle={courseTitle}
            amount={purchase.remainAmount} // only remaining goes in cart
            levelbadge={levelbadge}
            mode="remaining"
            asLink={true}
            className="reserve-link"
            onClick={handleClick} // ✅ all clicks go through here
          >
            Pay Remaining
          </AddToCartButton> */}
        </div>
      </div>
    );
  }

  // ✅ No purchase → Reserve Seat (25%)
  if (errorCode === 404 || errorCode === 400 || !purchase) {
    // const reserveAmount = amount * 0.25;
    return (
      <div
        className="reserve-container"
        style={{ display: "flex", alignItems: "center", gap: "10px",cursor: "pointer",}}
      >
        <AddToCartButton
          courseId={courseId}
          levelId={levelId}
          courseTitle={courseTitle}
          amount={amount}
          levelbadge={levelbadge}
          mode="partial"
          asLink={true}
          className="reserve-link"
          onClick={(e) => handleClick(e)}
        >
          Can't make up your mind? reserve your seat for a nominal fee
        </AddToCartButton>
      </div>
    );
  }

  return null;
}
